// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3gzp1","footer":"ModalCreateQualiphyProcedure_footer__3GtFH","additionData":"ModalCreateQualiphyProcedure_additionData__16nE4"};